module.exports = __webpack_public_path__ + "img/EC.d75b6c59.svg";